<div class="report-viewer-modal">
  <button class="close-button" (click)="closeModal()"><mat-icon>close</mat-icon></button>

  <iframe [src]="pdfUrl" width="100%" style="height: 100%;"> </iframe>




</div>